import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function StickyEndsArea(): JSX.Element {
  return (
    <fieldset>
      <legend>Sticky Ends</legend>
      <div className="row">
        <div className="col col-md-12">
          <table className="table table-condensed table-hover">
            <thead>
              <tr>
                <th>Upstream</th>
                <th>Downstream</th>
                <th>
                  Bases
                  <a
                    className={
                      'glyphicon glyphicon-info-sign u-no-text-decoration ' +
                      'u-tiny-spacing-left js-finalized-message hidden'
                    }
                  />
                </th>
                <th>Reverse Complement</th>
              </tr>
            </thead>
            <tbody className="js-sticky-ends-tbody" />
          </table>
          <div className="assembly-check-mount" />
        </div>
      </div>
    </fieldset>
  );
}

export default makeDeprecatedJadeStyleTemplate(StickyEndsArea);
